import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateEducationalUnit($data: CreateEducationalUnitInput!) {
    createEducationalUnit(data: $data) {
      id
      name
      active
    }
  }
`);

export interface CreateGql {
  createEducationalUnit: {
    id: number;
    name: string;
    active: boolean;
  };
}
